export default __webpack_public_path__ + "static/media/no_image.8525b76d.png";